//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap, catchError } from 'rxjs/operators';
import { Observable, from, throwError, of } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const OM_CUSTOMER_API_BASE_URL = new InjectionToken<string>('OM_CUSTOMER_API_BASE_URL');

export class ServiceBaseConfig {
    public key: string;
}

export class ServiceBase {
    private readonly apiKey: string;
    private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
    private readonly tenantIdHeaderName: string = 'TenantId';
    private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
    private readonly idTokenKey: string = 'samplicity-id-token';

    constructor(config: ServiceBaseConfig) {
        this.apiKey = config.key;
    }

    protected transformOptions(options: any) {
        let headers: HttpHeaders = options.headers;

        if (this.apiKey) {
            headers = headers.append(this.apimHeaderName, this.apiKey);
        }

        const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
        if (tenantId) {
            headers = headers.append(this.tenantIdHeaderName, tenantId);
        }

        const token = localStorage.getItem(this.idTokenKey);
        if (token) {
            headers = headers.append('Authorization', 'Bearer ' + token);
        }

        options.headers = headers;

        return Promise.resolve(options);
    }
}

@Injectable()
export class OrderManagementCustomer extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OM_CUSTOMER_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCustomerAccountNumberList(): Observable<AjaxResponseOfListOfCustomerAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerAccountNumberList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(mergeMap((response_: any) => {
            return this.processGetCustomerAccountNumberList(response_);
        })).pipe(catchError((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerAccountNumberList(response_ as any);
                } catch (e) {
                    return throwError(e) as any as Observable<AjaxResponseOfListOfCustomerAccountDto>;
                }
            } else
                return throwError(response_) as any as Observable<AjaxResponseOfListOfCustomerAccountDto>;
        }));
    }

    protected processGetCustomerAccountNumberList(response: HttpResponseBase): Observable<AjaxResponseOfListOfCustomerAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfListOfCustomerAccountDto.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getCustomerDeliveryAddress(orderId: string | null | undefined): Observable<AjaxResponseOfListOfCustomerDeliveryAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerDeliveryAddress?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(mergeMap((response_: any) => {
            return this.processGetCustomerDeliveryAddress(response_);
        })).pipe(catchError((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerDeliveryAddress(response_ as any);
                } catch (e) {
                    return throwError(e) as any as Observable<AjaxResponseOfListOfCustomerDeliveryAddressDto>;
                }
            } else
                return throwError(response_) as any as Observable<AjaxResponseOfListOfCustomerDeliveryAddressDto>;
        }));
    }

    protected processGetCustomerDeliveryAddress(response: HttpResponseBase): Observable<AjaxResponseOfListOfCustomerDeliveryAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfListOfCustomerDeliveryAddressDto.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param sortBy (optional) 
     * @return Success
     */
    getAllCustomerDeliveryAddress(customerId: string | null | undefined, pageSize: number | null | undefined, pageNumber: number | null | undefined, sortBy: string | null | undefined): Observable<AjaxResponseOfPagedResultOfCustomerAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetAllCustomerDeliveryAddress?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(mergeMap((response_: any) => {
            return this.processGetAllCustomerDeliveryAddress(response_);
        })).pipe(catchError((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomerDeliveryAddress(response_ as any);
                } catch (e) {
                    return throwError(e) as any as Observable<AjaxResponseOfPagedResultOfCustomerAddressDto>;
                }
            } else
                return throwError(response_) as any as Observable<AjaxResponseOfPagedResultOfCustomerAddressDto>;
        }));
    }

    protected processGetAllCustomerDeliveryAddress(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfCustomerAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfPagedResultOfCustomerAddressDto.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    searchCustomers(filter: CustomerSearchFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfCustomerSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/SearchCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(mergeMap((response_: any) => {
            return this.processSearchCustomers(response_);
        })).pipe(catchError((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomers(response_ as any);
                } catch (e) {
                    return throwError(e) as any as Observable<AjaxResponseOfPagedResultOfCustomerSearchDto>;
                }
            } else
                return throwError(response_) as any as Observable<AjaxResponseOfPagedResultOfCustomerSearchDto>;
        }));
    }

    protected processSearchCustomers(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfCustomerSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfPagedResultOfCustomerSearchDto.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null as any);
    }

    protected processSyncCustomerDetailsFromD365(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfBoolean.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of<AjaxResponseOfBoolean>(null as any);
    }

    /**
     * To get Customer Configurations
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerConfigurations(customerId: string | null | undefined): Observable<AjaxResponseOfCustomerConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerConfigurations?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(mergeMap((response_: any) => {
            return this.processGetCustomerConfigurations(response_);
        })).pipe(catchError((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerConfigurations(response_ as any);
                } catch (e) {
                    return throwError(e) as any as Observable<AjaxResponseOfCustomerConfigurationDto>;
                }
            } else
                return throwError(response_) as any as Observable<AjaxResponseOfCustomerConfigurationDto>;
        }));
    }

    protected processGetCustomerConfigurations(response: HttpResponseBase): Observable<AjaxResponseOfCustomerConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfCustomerConfigurationDto.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null as any);
    }

    /**
     * To set Customer Configurations
     * @param customerConfigurationDto (optional) 
     * @return Success
     */
    setCustomerConfigurations(customerConfigurationDto: CustomerConfigurationDto | null | undefined): Observable<AjaxResponseOfCustomerConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/SetCustomerConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerConfigurationDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(mergeMap((response_: any) => {
            return this.processSetCustomerConfigurations(response_);
        })).pipe(catchError((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCustomerConfigurations(response_ as any);
                } catch (e) {
                    return throwError(e) as any as Observable<AjaxResponseOfCustomerConfigurationDto>;
                }
            } else
                return throwError(response_) as any as Observable<AjaxResponseOfCustomerConfigurationDto>;
        }));
    }

    protected processSetCustomerConfigurations(response: HttpResponseBase): Observable<AjaxResponseOfCustomerConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfCustomerConfigurationDto.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    resetOrderingPlatformCustomer(customerId: string | null | undefined): Observable<AjaxResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Customer/ResetOrderingPlatformCustomer?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(mergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(mergeMap((response_: any) => {
            return this.processResetOrderingPlatformCustomer(response_);
        })).pipe(catchError((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetOrderingPlatformCustomer(response_ as any);
                } catch (e) {
                    return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
                }
            } else
                return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
        }));
    }

    protected processResetOrderingPlatformCustomer(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfBoolean.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(null as any);
    }

    /**
     * @param customerOPRequestDto (optional) 
     * @return Success
     */
    oPToOMSCustomerCreation(customerOPRequestDto: CustomerOPRequestDto | null | undefined): Observable<AjaxResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Customer/OPToOMSCustomerCreation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerOPRequestDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(
            mergeMap(transformedOptions_ => {
                return this.http.request("post", url_, transformedOptions_);
            }),
            mergeMap((response_: any) => {
                return this.processOPToOMSCustomerCreation(response_);
            }),
            catchError((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processOPToOMSCustomerCreation(response_ as any);
                    } catch (e) {
                        return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
                    }
                } else {
                    return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
                }
            })
        );
    }

    protected processOPToOMSCustomerCreation(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfBoolean.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of<AjaxResponseOfBoolean>(null as any);
    }

    /**
     * @param customerAddressOPRequestDto (optional) 
     * @return Success
     */
    oPToOMSCustomerAddressCreation(customerAddressOPRequestDto: CustomerAddressOPRequestDto | null | undefined): Observable<AjaxResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Customer/OPToOMSCustomerAddressCreation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerAddressOPRequestDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return from(this.transformOptions(options_)).pipe(
            mergeMap(transformedOptions_ => {
                return this.http.request("post", url_, transformedOptions_);
            }),
            mergeMap((response_: any) => {
                return this.processOPToOMSCustomerAddressCreation(response_);
            }),
            catchError((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processOPToOMSCustomerAddressCreation(response_ as any);
                    } catch (e) {
                        return throwError(e) as any as Observable<AjaxResponseOfBoolean>;
                    }
                } else
                    return throwError(response_) as any as Observable<AjaxResponseOfBoolean>;
            })
        );
    }

    protected processOPToOMSCustomerAddressCreation(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfBoolean.fromJS(resultData200);
                return of(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(mergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of<AjaxResponseOfBoolean>(null as any);
    }
}

export class AjaxResponseOfListOfCustomerAccountDto implements IAjaxResponseOfListOfCustomerAccountDto {
    result: CustomerAccountDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfCustomerAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(CustomerAccountDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfCustomerAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfCustomerAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfCustomerAccountDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfCustomerAccountDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfCustomerAccountDto {
    result: CustomerAccountDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CustomerAccountDto implements ICustomerAccountDto {
    tenantId: number | undefined;
    customerId: string | undefined;
    customerAccountNumber: string | undefined;
    customerName: string | undefined;

    constructor(data?: ICustomerAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.customerId = _data["customerId"];
            this.customerAccountNumber = _data["customerAccountNumber"];
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): CustomerAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["customerAccountNumber"] = this.customerAccountNumber;
        data["customerName"] = this.customerName;
        return data;
    }

    clone(): CustomerAccountDto {
        const json = this.toJSON();
        let result = new CustomerAccountDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerAccountDto {
    tenantId: number | undefined;
    customerId: string | undefined;
    customerAccountNumber: string | undefined;
    customerName: string | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class AjaxResponseOfListOfCustomerDeliveryAddressDto implements IAjaxResponseOfListOfCustomerDeliveryAddressDto {
    result: CustomerDeliveryAddressDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfCustomerDeliveryAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(CustomerDeliveryAddressDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfCustomerDeliveryAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfCustomerDeliveryAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfCustomerDeliveryAddressDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfCustomerDeliveryAddressDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfCustomerDeliveryAddressDto {
    result: CustomerDeliveryAddressDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CustomerDeliveryAddressDto implements ICustomerDeliveryAddressDto {
    id: string | undefined;
    tenantId: number | undefined;
    isActive: boolean | undefined;
    customerId: string | undefined;
    customerAccountNbr: string | undefined;
    addressLocationId: string | undefined;
    addressLocationRoles: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    countryCodeId: string | undefined;
    customerTypeClassification: string | undefined;
    sln: string | undefined;
    dea: string | undefined;
    san: string | undefined;
    attention: string | undefined;
    recipientCountryCode: string | undefined;
    recipientCountryCodeId: string | undefined;

    constructor(data?: ICustomerDeliveryAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.isActive = _data["isActive"];
            this.customerId = _data["customerId"];
            this.customerAccountNbr = _data["customerAccountNbr"];
            this.addressLocationId = _data["addressLocationId"];
            this.addressLocationRoles = _data["addressLocationRoles"];
            this.address1Text = _data["address1Text"];
            this.address2Text = _data["address2Text"];
            this.address3Text = _data["address3Text"];
            this.address4Text = _data["address4Text"];
            this.cityName = _data["cityName"];
            this.zipCode = _data["zipCode"];
            this.stateCode = _data["stateCode"];
            this.countryCode = _data["countryCode"];
            this.countryCodeId = _data["countryCodeId"];
            this.customerTypeClassification = _data["customerTypeClassification"];
            this.sln = _data["sln"];
            this.dea = _data["dea"];
            this.san = _data["san"];
            this.attention = _data["attention"];
            this.recipientCountryCode = _data["recipientCountryCode"];
            this.recipientCountryCodeId = _data["recipientCountryCodeId"];
        }
    }

    static fromJS(data: any): CustomerDeliveryAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDeliveryAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["isActive"] = this.isActive;
        data["customerId"] = this.customerId;
        data["customerAccountNbr"] = this.customerAccountNbr;
        data["addressLocationId"] = this.addressLocationId;
        data["addressLocationRoles"] = this.addressLocationRoles;
        data["address1Text"] = this.address1Text;
        data["address2Text"] = this.address2Text;
        data["address3Text"] = this.address3Text;
        data["address4Text"] = this.address4Text;
        data["cityName"] = this.cityName;
        data["zipCode"] = this.zipCode;
        data["stateCode"] = this.stateCode;
        data["countryCode"] = this.countryCode;
        data["countryCodeId"] = this.countryCodeId;
        data["customerTypeClassification"] = this.customerTypeClassification;
        data["sln"] = this.sln;
        data["dea"] = this.dea;
        data["san"] = this.san;
        data["attention"] = this.attention;
        data["recipientCountryCode"] = this.recipientCountryCode;
        data["recipientCountryCodeId"] = this.recipientCountryCodeId;
        return data;
    }

    clone(): CustomerDeliveryAddressDto {
        const json = this.toJSON();
        let result = new CustomerDeliveryAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDeliveryAddressDto {
    id: string | undefined;
    tenantId: number | undefined;
    isActive: boolean | undefined;
    customerId: string | undefined;
    customerAccountNbr: string | undefined;
    addressLocationId: string | undefined;
    addressLocationRoles: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    countryCodeId: string | undefined;
    customerTypeClassification: string | undefined;
    sln: string | undefined;
    dea: string | undefined;
    san: string | undefined;
    attention: string | undefined;
    recipientCountryCode: string | undefined;
    recipientCountryCodeId: string | undefined;
}

export class AjaxResponseOfPagedResultOfCustomerAddressDto implements IAjaxResponseOfPagedResultOfCustomerAddressDto {
    result: PagedResultOfCustomerAddressDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfPagedResultOfCustomerAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PagedResultOfCustomerAddressDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPagedResultOfCustomerAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPagedResultOfCustomerAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfPagedResultOfCustomerAddressDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfPagedResultOfCustomerAddressDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfPagedResultOfCustomerAddressDto {
    result: PagedResultOfCustomerAddressDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class PagedResultOfCustomerAddressDto implements IPagedResultOfCustomerAddressDto {
    totalCount: number | undefined;
    items: CustomerAddressDto[] | undefined;

    constructor(data?: IPagedResultOfCustomerAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfCustomerAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCustomerAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultOfCustomerAddressDto {
        const json = this.toJSON();
        let result = new PagedResultOfCustomerAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfCustomerAddressDto {
    totalCount: number | undefined;
    items: CustomerAddressDto[] | undefined;
}

export class CustomerAddressDto implements ICustomerAddressDto {
    addressLocationId: string | undefined;
    addressDescription: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    isActive: boolean | undefined;
    lineOfBusinessCode: string | undefined;
    attention: string | undefined;
    addressLocationRoles: string | undefined;
    customerShipToNumber: string | undefined;
    shipToEmail: string | undefined;
    customerDeliveryAddressLicenses: CustomerDeliveryAddressLicenseDto[] | undefined;

    constructor(data?: ICustomerAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    (this as any)[property] = (data as any)[property];
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLocationId = _data["addressLocationId"];
            this.addressDescription = _data["addressDescription"];
            this.address1Text = _data["address1Text"];
            this.address2Text = _data["address2Text"];
            this.cityName = _data["cityName"];
            this.zipCode = _data["zipCode"];
            this.stateCode = _data["stateCode"];
            this.countryCode = _data["countryCode"];
            this.isActive = _data["isActive"];
            this.lineOfBusinessCode = _data["lineOfBusinessCode"];
            this.attention = _data["attention"];
            this.addressLocationRoles = _data["addressLocationRoles"];
            this.customerShipToNumber = _data["customerShipToNumber"];
            this.shipToEmail = _data["shipToEmail"];
            if (Array.isArray(_data["customerDeliveryAddressLicenses"])) {
                this.customerDeliveryAddressLicenses = [] as any;
                for (let item of _data["customerDeliveryAddressLicenses"])
                    this.customerDeliveryAddressLicenses.push(CustomerDeliveryAddressLicenseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLocationId"] = this.addressLocationId;
        data["addressDescription"] = this.addressDescription;
        data["address1Text"] = this.address1Text;
        data["address2Text"] = this.address2Text;
        data["cityName"] = this.cityName;
        data["zipCode"] = this.zipCode;
        data["stateCode"] = this.stateCode;
        data["countryCode"] = this.countryCode;
        data["isActive"] = this.isActive;
        data["lineOfBusinessCode"] = this.lineOfBusinessCode;
        data["attention"] = this.attention;
        data["addressLocationRoles"] = this.addressLocationRoles;
        data["customerShipToNumber"] = this.customerShipToNumber;
        data["shipToEmail"] = this.shipToEmail;
        if (Array.isArray(this.customerDeliveryAddressLicenses)) {
            data["customerDeliveryAddressLicenses"] = [];
            for (let item of this.customerDeliveryAddressLicenses)
                data["customerDeliveryAddressLicenses"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerAddressDto {
        const json = this.toJSON();
        let result = new CustomerAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressDto {
    addressLocationId: string | undefined;
    addressDescription: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    isActive: boolean | undefined;
    lineOfBusinessCode: string | undefined;
    attention: string | undefined;
    addressLocationRoles: string | undefined;
    customerShipToNumber: string | undefined;
    shipToEmail: string | undefined;
    customerDeliveryAddressLicenses: CustomerDeliveryAddressLicenseDto[] | undefined;
}

export class CustomerDeliveryAddressLicenseDto implements ICustomerDeliveryAddressLicenseDto {
    isActive: boolean | undefined;
    deliveryAddressId: string | undefined;
    registrationType: string | undefined;
    registrationNumber: string | undefined;

    constructor(data?: ICustomerDeliveryAddressLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.deliveryAddressId = _data["deliveryAddressId"];
            this.registrationType = _data["registrationType"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): CustomerDeliveryAddressLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDeliveryAddressLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["deliveryAddressId"] = this.deliveryAddressId;
        data["registrationType"] = this.registrationType;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }

    clone(): CustomerDeliveryAddressLicenseDto {
        const json = this.toJSON();
        let result = new CustomerDeliveryAddressLicenseDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDeliveryAddressLicenseDto {
    isActive: boolean | undefined;
    deliveryAddressId: string | undefined;
    registrationType: string | undefined;
    registrationNumber: string | undefined;
}

export class CustomerSearchFilterDto implements ICustomerSearchFilterDto {
    customerAccountNbr: string | undefined;
    customerName: string | undefined;
    customerClassificationId: string[] | undefined;
    isActive: boolean[] | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;

    constructor(data?: ICustomerSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountNbr = _data["customerAccountNbr"];
            this.customerName = _data["customerName"];
            if (Array.isArray(_data["customerClassificationId"])) {
                this.customerClassificationId = [] as any;
                for (let item of _data["customerClassificationId"])
                    this.customerClassificationId.push(item);
            }
            if (Array.isArray(_data["isActive"])) {
                this.isActive = [] as any;
                for (let item of _data["isActive"])
                    this.isActive.push(item);
            }
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.sortBy = _data["sortBy"];
            this.filterString = _data["filterString"];
        }
    }

    static fromJS(data: any): CustomerSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountNbr"] = this.customerAccountNbr;
        data["customerName"] = this.customerName;
        if (Array.isArray(this.customerClassificationId)) {
            data["customerClassificationId"] = [];
            for (let item of this.customerClassificationId)
                data["customerClassificationId"].push(item);
        }
        if (Array.isArray(this.isActive)) {
            data["isActive"] = [];
            for (let item of this.isActive)
                data["isActive"].push(item);
        }
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["sortBy"] = this.sortBy;
        data["filterString"] = this.filterString;
        return data;
    }

    clone(): CustomerSearchFilterDto {
        const json = this.toJSON();
        let result = new CustomerSearchFilterDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerSearchFilterDto {
    customerAccountNbr: string | undefined;
    customerName: string | undefined;
    customerClassificationId: string[] | undefined;
    isActive: boolean[] | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfCustomerSearchDto implements IAjaxResponseOfPagedResultOfCustomerSearchDto {
    result: PagedResultOfCustomerSearchDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfPagedResultOfCustomerSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PagedResultOfCustomerSearchDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPagedResultOfCustomerSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPagedResultOfCustomerSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfPagedResultOfCustomerSearchDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfPagedResultOfCustomerSearchDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfPagedResultOfCustomerSearchDto {
    result: PagedResultOfCustomerSearchDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class PagedResultOfCustomerSearchDto implements IPagedResultOfCustomerSearchDto {
    totalCount: number | undefined;
    items: CustomerSearchDto[] | undefined;

    constructor(data?: IPagedResultOfCustomerSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfCustomerSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCustomerSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultOfCustomerSearchDto {
        const json = this.toJSON();
        let result = new PagedResultOfCustomerSearchDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfCustomerSearchDto {
    totalCount: number | undefined;
    items: CustomerSearchDto[] | undefined;
}

export class CustomerSearchDto implements ICustomerSearchDto {
    customerAccountNbr: string | undefined;
    customerClassificationId: string | undefined;
    isActive: string | undefined;
    tenantId: number | undefined;
    customerId: string | undefined;
    customerAccountNumber: string | undefined;
    customerName: string | undefined;

    constructor(data?: ICustomerSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountNbr = _data["customerAccountNbr"];
            this.customerClassificationId = _data["customerClassificationId"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.customerId = _data["customerId"];
            this.customerAccountNumber = _data["customerAccountNumber"];
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): CustomerSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountNbr"] = this.customerAccountNbr;
        data["customerClassificationId"] = this.customerClassificationId;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["customerAccountNumber"] = this.customerAccountNumber;
        data["customerName"] = this.customerName;
        return data;
    }

    clone(): CustomerSearchDto {
        const json = this.toJSON();
        let result = new CustomerSearchDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerSearchDto {
    customerAccountNbr: string | undefined;
    customerClassificationId: string | undefined;
    isActive: string | undefined;
    tenantId: number | undefined;
    customerId: string | undefined;
    customerAccountNumber: string | undefined;
    customerName: string | undefined;
}

export class AjaxResponseOfBoolean implements IAjaxResponseOfBoolean {
    result: boolean | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfBoolean {
        const json = this.toJSON();
        let result = new AjaxResponseOfBoolean();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfBoolean {
    result: boolean | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfCustomerConfigurationDto implements IAjaxResponseOfCustomerConfigurationDto {
    result: CustomerConfigurationDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfCustomerConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CustomerConfigurationDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfCustomerConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfCustomerConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfCustomerConfigurationDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfCustomerConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfCustomerConfigurationDto {
    result: CustomerConfigurationDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CustomerConfigurationDto implements ICustomerConfigurationDto {
    customer: CustomerDto | undefined;
    orderSlaWorkingDays: number | undefined;
    placeOrderOnAnyDay: boolean | undefined;
    placeOrderOnMonday: boolean | undefined;
    placeOrderOnTuesday: boolean | undefined;
    placeOrderOnWednesday: boolean | undefined;
    placeOrderOnThursday: boolean | undefined;
    placeOrderOnFriday: boolean | undefined;
    orderReceivedCutoffTime: string | undefined;
    productLevelCarrierServiceTypeId: string | undefined;
    anySpecificShipmentPickupDay: boolean | undefined;
    shippingComments: string | undefined;
    customerConfigurationProducts: CustomerConfigurationProductDto[] | undefined;
    customerConfigurationProductTypes: CustomerConfigurationProductTypeDto[] | undefined;
    customerConfigurationShipments: CustomerConfigurationShipmentDto[] | undefined;
    id: string | undefined;

    constructor(data?: ICustomerConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.orderSlaWorkingDays = _data["orderSlaWorkingDays"];
            this.placeOrderOnAnyDay = _data["placeOrderOnAnyDay"];
            this.placeOrderOnMonday = _data["placeOrderOnMonday"];
            this.placeOrderOnTuesday = _data["placeOrderOnTuesday"];
            this.placeOrderOnWednesday = _data["placeOrderOnWednesday"];
            this.placeOrderOnThursday = _data["placeOrderOnThursday"];
            this.placeOrderOnFriday = _data["placeOrderOnFriday"];
            this.orderReceivedCutoffTime = _data["orderReceivedCutoffTime"];
            this.productLevelCarrierServiceTypeId = _data["productLevelCarrierServiceTypeId"];
            this.anySpecificShipmentPickupDay = _data["anySpecificShipmentPickupDay"];
            this.shippingComments = _data["shippingComments"];
            if (Array.isArray(_data["customerConfigurationProducts"])) {
                this.customerConfigurationProducts = [] as any;
                for (let item of _data["customerConfigurationProducts"])
                    this.customerConfigurationProducts.push(CustomerConfigurationProductDto.fromJS(item));
            }
            if (Array.isArray(_data["customerConfigurationProductTypes"])) {
                this.customerConfigurationProductTypes = [] as any;
                for (let item of _data["customerConfigurationProductTypes"])
                    this.customerConfigurationProductTypes.push(CustomerConfigurationProductTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["customerConfigurationShipments"])) {
                this.customerConfigurationShipments = [] as any;
                for (let item of _data["customerConfigurationShipments"])
                    this.customerConfigurationShipments.push(CustomerConfigurationShipmentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["orderSlaWorkingDays"] = this.orderSlaWorkingDays;
        data["placeOrderOnAnyDay"] = this.placeOrderOnAnyDay;
        data["placeOrderOnMonday"] = this.placeOrderOnMonday;
        data["placeOrderOnTuesday"] = this.placeOrderOnTuesday;
        data["placeOrderOnWednesday"] = this.placeOrderOnWednesday;
        data["placeOrderOnThursday"] = this.placeOrderOnThursday;
        data["placeOrderOnFriday"] = this.placeOrderOnFriday;
        data["orderReceivedCutoffTime"] = this.orderReceivedCutoffTime;
        data["productLevelCarrierServiceTypeId"] = this.productLevelCarrierServiceTypeId;
        data["anySpecificShipmentPickupDay"] = this.anySpecificShipmentPickupDay;
        data["shippingComments"] = this.shippingComments;
        if (Array.isArray(this.customerConfigurationProducts)) {
            data["customerConfigurationProducts"] = [];
            for (let item of this.customerConfigurationProducts)
                data["customerConfigurationProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.customerConfigurationProductTypes)) {
            // data["customerConfigurationProductTypes"] = [];
            // for (let item of this.customerConfigurationProductTypes)
            //     data["customerConfigurationProductTypes"].push(item.toJSON());
            data["customerConfigurationProductTypes"] = this.customerConfigurationProductTypes.map(item => {
                const typedItem = item instanceof CustomerConfigurationProductTypeDto
                    ? item
                    : CustomerConfigurationProductTypeDto.fromJS(item);
                return typedItem.toJSON();
            });
        }
        if (Array.isArray(this.customerConfigurationShipments)) {
            // data["customerConfigurationShipments"] = [];
            // for (let item of this.customerConfigurationShipments)
            //     data["customerConfigurationShipments"].push(item.toJSON());
            data["customerConfigurationShipments"] = this.customerConfigurationShipments.map(item => {
                const typedItem = item instanceof CustomerConfigurationShipmentDto
                    ? item
                    : CustomerConfigurationShipmentDto.fromJS(item);
                return typedItem.toJSON();
            });
        }
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerConfigurationDto {
        const json = this.toJSON();
        let result = new CustomerConfigurationDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerConfigurationDto {
    customer: CustomerDto | undefined;
    orderSlaWorkingDays: number | undefined;
    placeOrderOnAnyDay: boolean | undefined;
    placeOrderOnMonday: boolean | undefined;
    placeOrderOnTuesday: boolean | undefined;
    placeOrderOnWednesday: boolean | undefined;
    placeOrderOnThursday: boolean | undefined;
    placeOrderOnFriday: boolean | undefined;
    orderReceivedCutoffTime: string | undefined;
    productLevelCarrierServiceTypeId: string | undefined;
    anySpecificShipmentPickupDay: boolean | undefined;
    shippingComments: string | undefined;
    customerConfigurationProducts: CustomerConfigurationProductDto[] | undefined;
    customerConfigurationProductTypes: CustomerConfigurationProductTypeDto[] | undefined;
    customerConfigurationShipments: CustomerConfigurationShipmentDto[] | undefined;
    id: string | undefined;
}

export class CustomerDto implements ICustomerDto {
    customerName: string | undefined;
    customerAccountNbr: string | undefined;
    isActive: boolean | undefined;
    customerTypeClassificationValueId: string | undefined;
    invoiceAccountNumber: string | undefined;
    primaryContactEmail: string | undefined;
    customerClassificationId: string | undefined;
    customerGroupId: string | undefined;
    lineOfBusinessCode: string | undefined;
    paymentMethodCode: string | undefined;
    paymentMethodValue: string | undefined;
    paymentTermsCode: string | undefined;
    paymentTermsValue: string | undefined;
    lineDiscountGroup: string | undefined;
    multilineDiscountGroup: string | undefined;
    totalDiscountGroup: string | undefined;
    priceGroup: string | undefined;
    clientCustomerNumber: string | undefined;
    id: string | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.customerAccountNbr = _data["customerAccountNbr"];
            this.isActive = _data["isActive"];
            this.customerTypeClassificationValueId = _data["customerTypeClassificationValueId"];
            this.invoiceAccountNumber = _data["invoiceAccountNumber"];
            this.primaryContactEmail = _data["primaryContactEmail"];
            this.customerClassificationId = _data["customerClassificationId"];
            this.customerGroupId = _data["customerGroupId"];
            this.lineOfBusinessCode = _data["lineOfBusinessCode"];
            this.paymentMethodCode = _data["paymentMethodCode"];
            this.paymentMethodValue = _data["paymentMethodValue"];
            this.paymentTermsCode = _data["paymentTermsCode"];
            this.paymentTermsValue = _data["paymentTermsValue"];
            this.lineDiscountGroup = _data["lineDiscountGroup"];
            this.multilineDiscountGroup = _data["multilineDiscountGroup"];
            this.totalDiscountGroup = _data["totalDiscountGroup"];
            this.priceGroup = _data["priceGroup"];
            this.clientCustomerNumber = _data["clientCustomerNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["customerAccountNbr"] = this.customerAccountNbr;
        data["isActive"] = this.isActive;
        data["customerTypeClassificationValueId"] = this.customerTypeClassificationValueId;
        data["invoiceAccountNumber"] = this.invoiceAccountNumber;
        data["primaryContactEmail"] = this.primaryContactEmail;
        data["customerClassificationId"] = this.customerClassificationId;
        data["customerGroupId"] = this.customerGroupId;
        data["lineOfBusinessCode"] = this.lineOfBusinessCode;
        data["paymentMethodCode"] = this.paymentMethodCode;
        data["paymentMethodValue"] = this.paymentMethodValue;
        data["paymentTermsCode"] = this.paymentTermsCode;
        data["paymentTermsValue"] = this.paymentTermsValue;
        data["lineDiscountGroup"] = this.lineDiscountGroup;
        data["multilineDiscountGroup"] = this.multilineDiscountGroup;
        data["totalDiscountGroup"] = this.totalDiscountGroup;
        data["priceGroup"] = this.priceGroup;
        data["clientCustomerNumber"] = this.clientCustomerNumber;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    customerName: string | undefined;
    customerAccountNbr: string | undefined;
    isActive: boolean | undefined;
    customerTypeClassificationValueId: string | undefined;
    invoiceAccountNumber: string | undefined;
    primaryContactEmail: string | undefined;
    customerClassificationId: string | undefined;
    customerGroupId: string | undefined;
    lineOfBusinessCode: string | undefined;
    paymentMethodCode: string | undefined;
    paymentMethodValue: string | undefined;
    paymentTermsCode: string | undefined;
    paymentTermsValue: string | undefined;
    lineDiscountGroup: string | undefined;
    multilineDiscountGroup: string | undefined;
    totalDiscountGroup: string | undefined;
    priceGroup: string | undefined;
    clientCustomerNumber: string | undefined;
    id: string | undefined;
}

export class CustomerConfigurationProductDto implements ICustomerConfigurationProductDto {
    product: CustomerConfigurationProductMasterDto | undefined;
    customerProductCode: string | undefined;
    uoMConversionTypeId: string | undefined;
    uoMConversionValue: number | undefined;
    uoMDisplayQuantity: string | undefined;
    id: string | undefined;

    constructor(data?: ICustomerConfigurationProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? CustomerConfigurationProductMasterDto.fromJS(_data["product"]) : <any>undefined;
            this.customerProductCode = _data["customerProductCode"];
            this.uoMConversionTypeId = _data["uoMConversionTypeId"];
            this.uoMConversionValue = _data["uoMConversionValue"];
            this.uoMDisplayQuantity = _data["uoMDisplayQuantity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerConfigurationProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConfigurationProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["customerProductCode"] = this.customerProductCode;
        data["uoMConversionTypeId"] = this.uoMConversionTypeId;
        data["uoMConversionValue"] = this.uoMConversionValue;
        data["uoMDisplayQuantity"] = this.uoMDisplayQuantity;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerConfigurationProductDto {
        const json = this.toJSON();
        let result = new CustomerConfigurationProductDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerConfigurationProductDto {
    product: CustomerConfigurationProductMasterDto | undefined;
    customerProductCode: string | undefined;
    uoMConversionTypeId: string | undefined;
    uoMConversionValue: number | undefined;
    uoMDisplayQuantity: string | undefined;
    id: string | undefined;
}

export class CustomerConfigurationProductTypeDto implements ICustomerConfigurationProductTypeDto {
    priority: number | undefined;
    productTypeId: string | undefined;
    primaryCarrierServiceTypeId: string | undefined;
    secondaryCarrierServiceTypeId: string | undefined;
    carrierServiceStatesJson: string | undefined;
    id: string | undefined;

    constructor(data?: ICustomerConfigurationProductTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priority = _data["priority"];
            this.productTypeId = _data["productTypeId"];
            this.primaryCarrierServiceTypeId = _data["primaryCarrierServiceTypeId"];
            this.secondaryCarrierServiceTypeId = _data["secondaryCarrierServiceTypeId"];
            this.carrierServiceStatesJson = _data["carrierServiceStatesJson"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerConfigurationProductTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConfigurationProductTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priority"] = this.priority;
        data["productTypeId"] = this.productTypeId;
        data["primaryCarrierServiceTypeId"] = this.primaryCarrierServiceTypeId;
        data["secondaryCarrierServiceTypeId"] = this.secondaryCarrierServiceTypeId;
        data["carrierServiceStatesJson"] = this.carrierServiceStatesJson;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerConfigurationProductTypeDto {
        const json = this.toJSON();
        let result = new CustomerConfigurationProductTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerConfigurationProductTypeDto {
    priority: number | undefined;
    productTypeId: string | undefined;
    primaryCarrierServiceTypeId: string | undefined;
    secondaryCarrierServiceTypeId: string | undefined;
    carrierServiceStatesJson: string | undefined;
    id: string | undefined;
}

export class CustomerConfigurationShipmentDto implements ICustomerConfigurationShipmentDto {
    lineIndex: number | undefined;
    pickupDay: string | undefined;
    pickupTime: string | undefined;
    id: string | undefined;

    constructor(data?: ICustomerConfigurationShipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineIndex = _data["lineIndex"];
            this.pickupDay = _data["pickupDay"];
            this.pickupTime = _data["pickupTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerConfigurationShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConfigurationShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineIndex"] = this.lineIndex;
        data["pickupDay"] = this.pickupDay;
        data["pickupTime"] = this.pickupTime;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerConfigurationShipmentDto {
        const json = this.toJSON();
        let result = new CustomerConfigurationShipmentDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerConfigurationShipmentDto {
    lineIndex: number | undefined;
    pickupDay: string | undefined;
    pickupTime: string | undefined;
    id: string | undefined;
}

export class CustomerConfigurationProductMasterDto implements ICustomerConfigurationProductMasterDto {
    productCode: string | undefined;
    productName: string | undefined;
    productTypeId: string | undefined;
    distributionUnitOfMeasure: string | undefined;
    productGroupId: string | undefined;
    id: string | undefined;

    constructor(data?: ICustomerConfigurationProductMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productTypeId = _data["productTypeId"];
            this.distributionUnitOfMeasure = _data["distributionUnitOfMeasure"];
            this.productGroupId = _data["productGroupId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerConfigurationProductMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerConfigurationProductMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productTypeId"] = this.productTypeId;
        data["distributionUnitOfMeasure"] = this.distributionUnitOfMeasure;
        data["productGroupId"] = this.productGroupId;
        data["id"] = this.id;
        return data;
    }

    clone(): CustomerConfigurationProductMasterDto {
        const json = this.toJSON();
        let result = new CustomerConfigurationProductMasterDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerConfigurationProductMasterDto {
    productCode: string | undefined;
    productName: string | undefined;
    productTypeId: string | undefined;
    distributionUnitOfMeasure: string | undefined;
    productGroupId: string | undefined;
    id: string | undefined;
}

export class CustomerOPRequestDto implements ICustomerOPRequestDto {
    integrationRequestId: string | undefined;
    tenantId: string | undefined;
    companyId: string | undefined;
    sourceSystem: string | undefined;
    customerOPInfo: CustomerOPInfoDto | undefined;
    validationErrors: CustomerOPRequestErrorDto[] | undefined;

    constructor(data?: ICustomerOPRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationRequestId = _data["integrationRequestId"];
            this.tenantId = _data["tenantId"];
            this.companyId = _data["companyId"];
            this.sourceSystem = _data["sourceSystem"];
            this.customerOPInfo = _data["customerOPInfo"] ? CustomerOPInfoDto.fromJS(_data["customerOPInfo"]) : <any>undefined;
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(CustomerOPRequestErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerOPRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOPRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationRequestId"] = this.integrationRequestId;
        data["tenantId"] = this.tenantId;
        data["companyId"] = this.companyId;
        data["sourceSystem"] = this.sourceSystem;
        data["customerOPInfo"] = this.customerOPInfo ? this.customerOPInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerOPRequestDto {
        const json = this.toJSON();
        let result = new CustomerOPRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerOPRequestDto {
    integrationRequestId: string | undefined;
    tenantId: string | undefined;
    companyId: string | undefined;
    sourceSystem: string | undefined;
    customerOPInfo: CustomerOPInfoDto | undefined;
    validationErrors: CustomerOPRequestErrorDto[] | undefined;
}

export class CustomerOPInfoDto implements ICustomerOPInfoDto {
    customerId: string | undefined;
    isActive: boolean | undefined;
    customerTypeClassificationValue: string | undefined;
    customerAccountNbr: string | undefined;
    customerName: string | undefined;
    invoiceAccountNumber: string | undefined;
    primaryContactEmail: string | undefined;
    customerClassificationId: string | undefined;
    customerGroupId: string | undefined;
    paymentTermsCode: string | undefined;
    paymentMethodCode: string | undefined;

    constructor(data?: ICustomerOPInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.isActive = _data["isActive"];
            this.customerTypeClassificationValue = _data["customerTypeClassificationValue"];
            this.customerAccountNbr = _data["customerAccountNbr"];
            this.customerName = _data["customerName"];
            this.invoiceAccountNumber = _data["invoiceAccountNumber"];
            this.primaryContactEmail = _data["primaryContactEmail"];
            this.customerClassificationId = _data["customerClassificationId"];
            this.customerGroupId = _data["customerGroupId"];
            this.paymentTermsCode = _data["paymentTermsCode"];
            this.paymentMethodCode = _data["paymentMethodCode"];
        }
    }

    static fromJS(data: any): CustomerOPInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOPInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["isActive"] = this.isActive;
        data["customerTypeClassificationValue"] = this.customerTypeClassificationValue;
        data["customerAccountNbr"] = this.customerAccountNbr;
        data["customerName"] = this.customerName;
        data["invoiceAccountNumber"] = this.invoiceAccountNumber;
        data["primaryContactEmail"] = this.primaryContactEmail;
        data["customerClassificationId"] = this.customerClassificationId;
        data["customerGroupId"] = this.customerGroupId;
        data["paymentTermsCode"] = this.paymentTermsCode;
        data["paymentMethodCode"] = this.paymentMethodCode;
        return data;
    }

    clone(): CustomerOPInfoDto {
        const json = this.toJSON();
        let result = new CustomerOPInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerOPInfoDto {
    customerId: string | undefined;
    isActive: boolean | undefined;
    customerTypeClassificationValue: string | undefined;
    customerAccountNbr: string | undefined;
    customerName: string | undefined;
    invoiceAccountNumber: string | undefined;
    primaryContactEmail: string | undefined;
    customerClassificationId: string | undefined;
    customerGroupId: string | undefined;
    paymentTermsCode: string | undefined;
    paymentMethodCode: string | undefined;
}

export class CustomerOPRequestErrorDto implements ICustomerOPRequestErrorDto {
    propertyName: string | undefined;
    errorMessage: string | undefined;

    constructor(data?: ICustomerOPRequestErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CustomerOPRequestErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOPRequestErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        return data;
    }

    clone(): CustomerOPRequestErrorDto {
        const json = this.toJSON();
        let result = new CustomerOPRequestErrorDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerOPRequestErrorDto {
    propertyName: string | undefined;
    errorMessage: string | undefined;
}

export class CustomerAddressOPRequestDto implements ICustomerAddressOPRequestDto {
    integrationRequestId: string | undefined;
    tenantId: string | undefined;
    companyId: string | undefined;
    sourceSystem: string | undefined;
    customerAddressOPInfo: CustomerAddressOPInfoDto | undefined;
    validationErrors: CustomerOPRequestErrorDto[] | undefined;

    constructor(data?: ICustomerAddressOPRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationRequestId = _data["integrationRequestId"];
            this.tenantId = _data["tenantId"];
            this.companyId = _data["companyId"];
            this.sourceSystem = _data["sourceSystem"];
            this.customerAddressOPInfo = _data["customerAddressOPInfo"] ? CustomerAddressOPInfoDto.fromJS(_data["customerAddressOPInfo"]) : <any>undefined;
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(CustomerOPRequestErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerAddressOPRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressOPRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationRequestId"] = this.integrationRequestId;
        data["tenantId"] = this.tenantId;
        data["companyId"] = this.companyId;
        data["sourceSystem"] = this.sourceSystem;
        data["customerAddressOPInfo"] = this.customerAddressOPInfo ? this.customerAddressOPInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerAddressOPRequestDto {
        const json = this.toJSON();
        let result = new CustomerAddressOPRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressOPRequestDto {
    integrationRequestId: string | undefined;
    tenantId: string | undefined;
    companyId: string | undefined;
    sourceSystem: string | undefined;
    customerAddressOPInfo: CustomerAddressOPInfoDto | undefined;
    validationErrors: CustomerOPRequestErrorDto[] | undefined;
}

export class CustomerAddressOPInfoDto implements ICustomerAddressOPInfoDto {
    addressId: string | undefined;
    customerId: string | undefined;
    addressLocationId: string | undefined;
    addressLocationRoles: string | undefined;
    addressDescription: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    attention: string | undefined;

    constructor(data?: ICustomerAddressOPInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.customerId = _data["customerId"];
            this.addressLocationId = _data["addressLocationId"];
            this.addressLocationRoles = _data["addressLocationRoles"];
            this.addressDescription = _data["addressDescription"];
            this.address1Text = _data["address1Text"];
            this.address2Text = _data["address2Text"];
            this.address3Text = _data["address3Text"];
            this.address4Text = _data["address4Text"];
            this.cityName = _data["cityName"];
            this.zipCode = _data["zipCode"];
            this.stateCode = _data["stateCode"];
            this.countryCode = _data["countryCode"];
            this.attention = _data["attention"];
        }
    }

    static fromJS(data: any): CustomerAddressOPInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressOPInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["customerId"] = this.customerId;
        data["addressLocationId"] = this.addressLocationId;
        data["addressLocationRoles"] = this.addressLocationRoles;
        data["addressDescription"] = this.addressDescription;
        data["address1Text"] = this.address1Text;
        data["address2Text"] = this.address2Text;
        data["address3Text"] = this.address3Text;
        data["address4Text"] = this.address4Text;
        data["cityName"] = this.cityName;
        data["zipCode"] = this.zipCode;
        data["stateCode"] = this.stateCode;
        data["countryCode"] = this.countryCode;
        data["attention"] = this.attention;
        return data;
    }

    clone(): CustomerAddressOPInfoDto {
        const json = this.toJSON();
        let result = new CustomerAddressOPInfoDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressOPInfoDto {
    addressId: string | undefined;
    customerId: string | undefined;
    addressLocationId: string | undefined;
    addressLocationRoles: string | undefined;
    addressDescription: string | undefined;
    address1Text: string | undefined;
    address2Text: string | undefined;
    address3Text: string | undefined;
    address4Text: string | undefined;
    cityName: string | undefined;
    zipCode: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    attention: string | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return throwError(result);
    else
        return throwError(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}